// ###########################################################################
// HEADER - Add class .min to scroll down
$(document).ready(function() {
  $(window).scroll(function() {
    // Calculate the scroll position
    var scrollPosition = $(window).scrollTop();

    // Check if the user has scrolled 300 pixels
    if (scrollPosition > 300) {
      // Add the 'min' class to the header
      $('.main-header').addClass('min');
    } else {
      // Remove the 'min' class if not scrolled 300 pixels
      $('.main-header').removeClass('min');
    }
  });
});

// ###########################################################################
// ANIMATION FADE TO TOP - element dom
var $animation_elements = $('.animated');
var $window = $(window);

function check_if_in_view() {
    var window_height = $window.height();
    var window_top_position = $window.scrollTop();
    var window_bottom_position = (window_top_position + window_height);

    $.each($animation_elements, function() {
        var $element = $(this);
        var element_height = $element.outerHeight();
        var element_top_position = $element.offset().top;
        var element_bottom_position = (element_top_position + element_height);

        //check to see if this current container is within viewport
        if ((element_bottom_position >= window_top_position) &&
            (element_top_position <= window_bottom_position)) {
            $element.addClass('active');
        }
        //else {
        //$element.removeClass('active');
        //}
    });
}

$window.on('scroll resize', check_if_in_view);
$window.trigger('scroll');

// ###########################################################################
// PRIMARY NAVIGATION
$("#btnMobile").click(function (e) {
  $(this).toggleClass("cross");
  $(".main-nav-wrapper").toggleClass("open");
  $("body").toggleClass("overflow");
});

// ###########################################################################
// SUBNAV NAVIGATION
$("ul > li.menu-item-has-children > a").click(function (e) {
    e.preventDefault();
    var LiParent =$(this).parent().attr('class');
    if(! LiParent.includes("openSub-menu") ){
        $('ul > li.menu-item-has-children > a').parent().removeClass("openSub-menu");
    }
    $(this).parent().toggleClass("openSub-menu");
});

// CLOSE NAV WHEN CLICK ANYWHERE
$(document).on("click", function (event) {
    var $trigger = $(".menu-item-has-children");
    if ($trigger !== event.target && !$trigger.has(event.target).length) {
        $(".menu-item-has-children").removeClass("openSub-menu");
    }
});

// ###########################################################################
// ANCRE
$('a[href^="#"]').on('click',function (e) {
    e.preventDefault();

    var nav = $('nav');
    var target = this.hash,
    $target = $(target);

    $('html, body').stop().animate({
        'scrollTop': $target.offset().top - nav.height()
    }, 1200, 'swing', function () {
        window.location.hash = target;
    });
});

// ###########################################################################
// SLICK - slideshow & slider
$(document).ready(function () {

  $('.content-slider-1-1 .wrapper-slider > .content').slick({
    slidesToShow: 2,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1400,
        settings: {
          centerMode: false,
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]

  });

  $('.content-1-1 .wrapper .gallery').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
  });

  var $slider = $('.slideshow .slider-wrapper');

  // Initialisation de Slick.js sans les dots natifs
  $slider.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    fade: true,
    dots: false,
    arrows: false
  });

  var slideCount = $slider.slick('getSlick').slideCount;
  var $dotsContainer = $('.custom-dots');

  // Générer les dots SVG dynamiquement
  for (var i = 0; i < slideCount; i++) {
    var $dot = $(
      '<button class="dot">' +
        '<svg viewBox="0 0 40 40">' +
          '<circle cx="20" cy="20" r="18" />' +
        '</svg>' +
      '</button>'
    );
    $dotsContainer.append($dot);
  }

  // Activer le premier dot
  $('.custom-dots .dot').first().addClass('active');

  // Gestion du clic sur un dot avec un délai
  $('.custom-dots .dot').click(function () {
    var index = $(this).index();

    // Désactiver tous les dots immédiatement
    $('.custom-dots .dot').removeClass('active');

    // Lancer le slide et activer le bon dot avec un léger délai pour la synchro
    $slider.slick('slickGoTo', index);
    setTimeout(function () {
      $('.custom-dots .dot').eq(index).addClass('active');
    }, 300); // Ajuste ce délai en fonction de la durée de l'animation Slick.js
  });

  // Mise à jour des dots après le changement de slide
  $slider.on('afterChange', function (event, slick, currentSlide) {
    $('.custom-dots .dot').removeClass('active');
    $('.custom-dots .dot').eq(currentSlide).addClass('active');
  });
});
